import { render, staticRenderFns } from "./ShowSchedule.vue?vue&type=template&id=52212667"
import script from "./ShowSchedule.vue?vue&type=script&lang=js"
export * from "./ShowSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports